export const downloadLinkId = 'download-link';
export const dashboardModalId = 'dashboard-modal-id';
export const emptyHiddenInputId = 'empty-hidden-input-id';
export const pageStepsId = 'form-steps';
